import {createSlice} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import {regexPatterns} from '../../../../utilities/validation/validationVariables';
import lodash from 'lodash';

const almostDoneSlice = createSlice({
  name: 'almostDone',
  initialState: {
    form: {
      phone: '',
      valid: '',

      errors: {
        phone: '',
      },
      rules: {},
    },
    phoneIsEdit: false,
    isTermsAccepted: false,
    isTermsMsg: false,
  },

  reducers: {
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    changeHandlerNew: (state, action) => {
      const phoneValue = action.payload.value;
      let regex = new RegExp(regexPatterns.phoneRegex);
      var test = regex.test(String(phoneValue).toLowerCase());
      let error = '';

      if (phoneValue !== '') {
        error = test ? '' : 'יש להזין מספר נייד תקין';
      } else {
        error = 'יש להזין מספר נייד';
      }
      state.form.valid = test;
      state.form.phone = phoneValue;
      state.form.errors.phone = error;
    },
    reportAnalytics: (state, action) => {},
    editPhone: {
      reducer(state, action) {
        state.form.phone = action.payload;
        if (!state.phoneIsEdit) {
          state.phoneIsEdit = true;
        } else {
          state.phoneIsEdit = false;
        }
      },
    },

    clearValid: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    setPhone: {
      reducer(state, action) {
        state.form.phone = action.payload;
      },
    },
    onCheck: {
      reducer(state, action) {
        if (!state.isTermsAccepted) state.isTermsAccepted = true;
      },
    },
    onUncheck: {
      reducer(state, action) {
        if (state.isTermsAccepted) state.isTermsAccepted = false;
      },
    },
    termsMsg: {
      reducer(state, action) {
        state.isTermsMsg = action.payload;
      },
    },
  },
});

export const {changeHandler, editPhone, setPhone, onCheck, onUncheck, termsMsg, clearValid, reportAnalytics, changeHandlerNew} =
  almostDoneSlice.actions;

export default almostDoneSlice.reducer;
